module.exports = __webpack_public_path__ + "img/icon-gas-bottle-capacity.cc4df749.svg";